import { ReactComponent as SuccessIcon } from 'assets/icons/1xbet/success-icon.svg';
import { useAmount, useTranslate } from 'hooks';
import { useAppSelector } from 'store/hooks';
import { ButtonKinds } from 'types/button';
import { transformDateMoment } from 'utils';

import { BaseCard, Button } from '../ui';

const CheckSuccess = () => {
  const { paymentData } = useAppSelector((state) => state.payment);
  const { formattedFullAmount } = useAmount();
  const { t } = useTranslate();

  return (
    <BaseCard>
      <div className="flex flex-col gap-6">
        <div className="flex justify-center items-center gap-3">
          <SuccessIcon className="w-6 md:w-8 h-6 md:h-8" />
          <span className="text-[18px] md:text-2xl leading-5 md:leading-[30px] font-semibold text-1xbet-black">
            {t('1xbet.payment-success')}
          </span>
        </div>
        <div className="text-base md:text-xl leading-5 md:leading-[30px] flex flex-col gap-4 md:gap-6">
          <dl className="flex flex-1">
            <dt className="text-1xbet-gray-100 w-full">{t('1xbet.info.transaction-number')}</dt>
            <dd className="text-1xbet-black w-full font-medium text-right">№{paymentData?.ID}</dd>
          </dl>
          <dl className="flex flex-1">
            <dt className="text-1xbet-gray-100 w-full">{t('1xbet.info.payment-date')}</dt>
            <dd className="text-1xbet-black w-full font-medium text-right">
              {paymentData?.date && transformDateMoment(paymentData?.date)}
            </dd>
          </dl>
          <dl className="flex flex-1">
            <dt className="text-1xbet-gray-100 w-full">{t('1xbet.info.transaction-number')}</dt>
            <dd className="text-1xbet-black w-full font-medium text-right">
              {formattedFullAmount}
            </dd>
          </dl>
        </div>
        <Button onClick={() => {}}>{t('1xbet.home-page')}</Button>
        <Button kind={ButtonKinds.secondary}>{t('1xbet.back')}</Button>
      </div>
    </BaseCard>
  );
};

export { CheckSuccess };
